import ApiService from '@/services/api.service'
import { DEFAULT_MAP_CENTER, DEFAULT_MAP_ZOOM, STORAGE_KEYS } from '@/config/constants'

const SELECTED_CITY_KEY = STORAGE_KEYS.SELECTED_CITY

const state = {
  regionConfig: null,
  userCities: [],
  selectedCityId: parseInt(localStorage.getItem(SELECTED_CITY_KEY)) || null,
}

const getters = {
  regionConfig: (state) => state.regionConfig,
  userCities: (state) => state.userCities,
  selectedCityId: (state) => state.selectedCityId,

  cityName: (state) => state.regionConfig?.city_display_name ?? '',

  mapCenter: (state) => state.regionConfig
    ? [state.regionConfig.map_center_lat, state.regionConfig.map_center_lon]
    : DEFAULT_MAP_CENTER,

  mapZoom: (state) => state.regionConfig?.map_default_zoom ?? DEFAULT_MAP_ZOOM,

  thresholds: (state) => state.regionConfig ?? {},
}

const actions = {
  async loadRegionConfig({ commit, state }) {
    if (state.regionConfig) return
    try {
      const response = await ApiService.getRegionConfig(state.selectedCityId)
      commit('SET_REGION_CONFIG', response.data)
    } catch (e) {
      // Не падаем — компоненты используют fallback-значения из getters
    }
  },

  async reloadRegionConfig({ commit, state }) {
    try {
      const response = await ApiService.getRegionConfig(state.selectedCityId)
      commit('SET_REGION_CONFIG', response.data)
    } catch (e) {
      // ignore
    }
  },

  async loadUserCities({ commit, state }) {
    try {
      const response = await ApiService.getUserCities()
      const cities = response.data || []
      commit('SET_USER_CITIES', cities)

      // Если сохранённый selectedCityId не входит в доступные города — сбрасываем
      if (state.selectedCityId && cities.length > 0) {
        const found = cities.find(c => c.id === state.selectedCityId)
        if (!found) {
          commit('SET_SELECTED_CITY_ID', null)
        }
      }
    } catch (e) {
      // ignore
    }
  },

  async selectCity({ commit, dispatch }, cityId) {
    commit('SET_SELECTED_CITY_ID', cityId)
    await dispatch('reloadRegionConfig')
  },
}

const mutations = {
  SET_REGION_CONFIG(state, config) {
    state.regionConfig = config
  },
  SET_USER_CITIES(state, cities) {
    state.userCities = cities
  },
  SET_SELECTED_CITY_ID(state, cityId) {
    state.selectedCityId = cityId
    if (cityId) {
      localStorage.setItem(SELECTED_CITY_KEY, cityId)
    } else {
      localStorage.removeItem(SELECTED_CITY_KEY)
    }
  },
}

export const configModule = { namespaced: true, state, getters, actions, mutations }
